export default __webpack_public_path__ + "static/media/keto_diet@2x.637bdffd.jpg";